/* unplugin-vue-components disabled */import script from "./MenuBody.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBody.vue?vue&type=script&setup=true&lang=js"

import "./MenuBody.vue?vue&type=style&index=0&id=27c9a803&lang=scss"

const __exports__ = script;

export default __exports__